import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import type { MenuItemProps } from '@rio-cloud/rio-uikit/MenuItem';
import type React from 'react';
import { useIntl } from 'react-intl';

type OrderSelectDropDownMenuProps = {
    onOpenCreateTourDialog: () => void;
    onSelectAllOpenOrders: () => void;
    onDeselectAllOpenOrders: () => void;
    onCancelSelectedOpenOrders: () => void;
    selectedOrdersCount: number;
    selectableOrdersCount: number;
};

const OrderTableSelectDropDownMenu = ({
    onOpenCreateTourDialog,
    onSelectAllOpenOrders,
    onDeselectAllOpenOrders,
    onCancelSelectedOpenOrders,
    selectedOrdersCount,
    selectableOrdersCount,
}: OrderSelectDropDownMenuProps) => {
    const intl = useIntl();

    const planOrdersActionTitle = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.plan.multiselect.title',

        defaultMessage: 'Plan selection',
    });
    const planOrdersMenuItem: MenuItemProps = {
        value: (
            <span className='display-flex gap-5'>
                <span className='rioglyph rioglyph-stack text-size-16' />
                <span>
                    {planOrdersActionTitle} ({selectedOrdersCount})
                </span>
            </span>
        ),
        onSelect: onOpenCreateTourDialog,
        disabled: selectedOrdersCount === 0,
    };

    const dividerMenuItem: MenuItemProps = {
        divider: true,
    };

    const hasNoSelectedOrder = selectedOrdersCount === 0;

    const selectAllOpen: MenuItemProps = {
        value: intl.formatMessage({
            id: 'intl-msg:ordercom-cloud-frontend.common.multi-select.select-all',
            defaultMessage: 'Select all',
        }),
        onSelect: onSelectAllOpenOrders,
        disabled: selectableOrdersCount === 0,
    };

    const unselectAll: MenuItemProps = {
        value: intl.formatMessage({
            id: 'intl-msg:ordercom-cloud-frontend.common.multi-select.unselect-all',
            defaultMessage: 'Unselect all',
        }),
        onSelect: onDeselectAllOpenOrders,
        disabled: hasNoSelectedOrder,
    };

    const cancelSelectedOrders: MenuItemProps = {
        value: intl.formatMessage({
            id: 'intl-msg:ordercom-cloud-frontend.orders.table.dropdown.cancel.title',
        }),
        onSelect: onCancelSelectedOpenOrders,
        disabled: hasNoSelectedOrder,
    };

    const handleOnOpen = (event?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
        if (event) {
            return event.stopPropagation();
        }
    };

    return (
        <ButtonDropdown
            title={<span className='rioglyph rioglyph-checkboxes' />}
            bsSize='sm'
            iconOnly
            items={[
                planOrdersMenuItem,
                dividerMenuItem,
                selectAllOpen,
                unselectAll,
                dividerMenuItem,
                cancelSelectedOrders,
            ]}
            data-testid='ordercom-multi-select-dropdown'
            onOpen={handleOnOpen}
        />
    );
};

export default OrderTableSelectDropDownMenu;
